(function () {
  document.documentElement.classList.remove('no-js');
  var bookingFrame = document.getElementById('sse-booking-frame');
  if (bookingFrame) {
    window.addEventListener('message', function (event) {
      if (event.origin !== 'https://form.jotform.com' || event.source !== bookingFrame.contentWindow || typeof event.data !== 'string') return;
      var parts = event.data.split(':');
      if (parts[0] === 'setHeight') {
        var height = Number(parts[1]);
        if (Number.isFinite(height) && height >= 200 && height <= 12000) bookingFrame.style.height = Math.ceil(height) + 'px';
      }
    });
  }
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-gallery-track]');
    var slides = track.querySelectorAll('.sse-gallery__slide');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    var count = gallery.querySelector('[data-gallery-count]');
    var current = 0;
    function fitPhoto() {
      if (!slides[current]) return;
      var img = slides[current].querySelector('img, video');
      if (!img) return;
      var width = img.videoWidth || img.naturalWidth || Number(img.getAttribute('width'));
      var height = img.videoHeight || img.naturalHeight || Number(img.getAttribute('height'));
      if (width && height) track.style.height = (track.clientWidth * height / width) + 'px';
    }
    function syncVideos() {
      slides.forEach(function (slide, index) {
        var video = slide.querySelector('video');
        if (!video) return;
        if (index !== current || document.hidden || window.matchMedia('(prefers-reduced-motion: reduce)').matches) { video.pause(); return; }
        video.muted = true;
        var request = video.play();
        if (request) request.catch(function () { /* Native controls remain available when autoplay is blocked. */ });
      });
    }
    slides.forEach(function (slide) {
      var media = slide.querySelector('img, video');
      if (!media) return;
      media.addEventListener('load', fitPhoto);
      media.addEventListener('loadedmetadata', fitPhoto);
    });
    document.addEventListener('visibilitychange', syncVideos);
    syncVideos();
    new ResizeObserver(fitPhoto).observe(gallery);
    fitPhoto();
    if (slides.length < 2) return;
    function go(index) {
      index = (index + slides.length) % slides.length;
      track.scrollTo({ left: index * track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    gallery.querySelector('[data-gallery-prev]').addEventListener('click', function () { go(current - 1); });
    gallery.querySelector('[data-gallery-next]').addEventListener('click', function () { go(current + 1); });
    thumbs.forEach(function (thumb, index) { thumb.addEventListener('click', function () { go(index); }); });
    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        go(current + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    track.addEventListener('scroll', function () {
      var previous = current;
      current = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
      if (previous !== current) syncVideos();
      fitPhoto();
      count.textContent = (current + 1) + ' / ' + slides.length;
      thumbs.forEach(function (thumb, index) { thumb.setAttribute('aria-pressed', String(index === current)); });
    }, { passive: true });
  });

  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () {
      var open = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!open));
      mobileMenu.hidden = open;
      document.body.classList.toggle('menu-open', !open);
    });
    mobileMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        menuToggle.setAttribute('aria-expanded', 'false');
        mobileMenu.hidden = true;
        document.body.classList.remove('menu-open');
      });
    });
  }

  var heroVideo = document.querySelector('[data-mobile-hero-video]');
  if (heroVideo) {
    var hero = heroVideo.closest('.sse-hero');
    var heroVideoSource = heroVideo.querySelector('source[data-src]');
    var heroVideoPlay = document.querySelector('[data-hero-video-play]');
    var mobileVideoQuery = window.matchMedia('(max-width: 760px)');
    var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    var setVideoFallback = function (show) {
      if (hero) hero.classList.toggle('video-needs-play', show);
    };
    var loadHeroVideo = function () {
      if (heroVideoSource && !heroVideoSource.src) {
        heroVideoSource.src = heroVideoSource.getAttribute('data-src');
        heroVideo.load();
      }
    };
    var playHeroVideo = function () {
      heroVideo.muted = true;
      heroVideo.defaultMuted = true;
      var playRequest = heroVideo.play();
      if (playRequest && typeof playRequest.then === 'function') {
        playRequest.then(function () { setVideoFallback(false); }).catch(function () { setVideoFallback(true); });
      }
    };
    var syncHeroVideo = function () {
      var shouldPlay = mobileVideoQuery.matches && !reducedMotionQuery.matches;
      if (!shouldPlay) {
        heroVideo.pause();
        setVideoFallback(false);
        return;
      }
      loadHeroVideo();
      playHeroVideo();
    };
    heroVideo.addEventListener('canplay', playHeroVideo);
    heroVideo.addEventListener('playing', function () { setVideoFallback(false); });
    heroVideo.addEventListener('ended', function () {
      heroVideo.currentTime = 0;
      playHeroVideo();
    });
    if (heroVideoPlay) {
      heroVideoPlay.addEventListener('click', function () {
        loadHeroVideo();
        playHeroVideo();
      });
    }
    syncHeroVideo();
    if (typeof mobileVideoQuery.addEventListener === 'function') {
      mobileVideoQuery.addEventListener('change', syncHeroVideo);
      reducedMotionQuery.addEventListener('change', syncHeroVideo);
    } else {
      mobileVideoQuery.addListener(syncHeroVideo);
      reducedMotionQuery.addListener(syncHeroVideo);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) heroVideo.pause();
      else syncHeroVideo();
    });
  }

  var filterButtons = document.querySelectorAll('[data-fleet-filter]');
  var fleetCards = Array.from(document.querySelectorAll('[data-fleet-card]'));
  var fleetSearch = document.querySelector('[data-fleet-search]');
  var fleetResults = document.querySelector('[data-fleet-results]');
  var fleetMake = document.querySelector('[data-fleet-make]');
  var fleetSort = document.querySelector('[data-fleet-sort]');
  var categoryOrder = {supercar:0,'sports-coupe':1,'luxury-suv':2,'luxury-sedan':3};
  var brandNames = ['Aston Martin','Audi','Bentley','BMW','Cadillac','Chevrolet','Ferrari','Lamborghini','McLaren','Mercedes','Porsche','Rolls-Royce'];
  function hasFleetCategory(card, category) { return (card.dataset.categories || card.dataset.category || '').split(/\s+/).includes(category); }
  function vehicleName(card) { return card.querySelector('h3').textContent.trim(); }
  function searchable(value) { return value.toLowerCase().replace(/[^a-z0-9]/g,''); }
  function vehicleBrand(card) { var name=searchable(vehicleName(card)); return brandNames.find(function(brand){return name.indexOf(searchable(brand))!==-1;}) || 'Other'; }
  function groupName(card) { return vehicleName(card).replace(/^\s*\d{4}\s+/,'').replace(/Mercedes-(?:AMG|Benz|Maybach)\s+/gi,'Mercedes ').replace(/G\s+63/gi,'G63').replace(/Rolls Royce/gi,'Rolls-Royce'); }
  function isConvertible(card) { return card.dataset.convertible === 'true' || /convertible|spider|spyder|cabrio/i.test(card.textContent); }
  function vehiclePriority(card) { var link = card.querySelector('a[href*="/products/"]'); var path = link ? link.getAttribute('href').split('?')[0].replace(/\/$/, '') : ''; return /\/2023-mercedes-amg-g-63-white$/.test(path) ? 0 : /\/2022-mercedes-amg-g63-satin-black$/.test(path) ? 1 : 2; }
  function vehicleRate(card) { return Number(card.dataset.price) || Number((card.querySelector('.sse-vehicle-card__pricing b') || card).textContent.replace(/[^0-9.]/g,''))*100; }
  var fleetParams = new URLSearchParams(window.location.search);
  var activeFilter = fleetParams.get('body')==='convertible' ? 'convertible' : fleetParams.get('category') || 'all';
  if (activeFilter === 'sports-coupe') activeFilter = 'sports-car';
  if (!['all','supercar','sports-car','coupe','convertible','luxury-suv','luxury-sedan','luxury'].includes(activeFilter)) activeFilter='all';
  if(fleetMake) { brandNames.filter(function(brand){return fleetCards.some(function(card){return vehicleBrand(card)===brand;});}).forEach(function(brand){var option=document.createElement('option');option.value=brand;option.textContent=brand;fleetMake.appendChild(option);}); var initialBrand=brandNames.find(function(brand){return searchable(brand)===searchable(fleetParams.get('make')||'');}); if(initialBrand)fleetMake.value=initialBrand; }
  if(fleetSearch && fleetParams.get('model')) fleetSearch.value=fleetParams.get('model').slice(0,80);
  function filterFleet() {
    var query=searchable(fleetSearch ? fleetSearch.value : ''); var visible=0;
    fleetCards.sort(function(a,b){var price=fleetSort&&fleetSort.value==='price-asc'?vehicleRate(a)-vehicleRate(b):fleetSort&&fleetSort.value==='price-desc'?vehicleRate(b)-vehicleRate(a):0;var category=(categoryOrder[a.dataset.category]||0)-(categoryOrder[b.dataset.category]||0);var priority=(!fleetSort||fleetSort.value==='grouped')?vehiclePriority(a)-vehiclePriority(b):0;return price||priority||category||groupName(a).localeCompare(groupName(b),'en',{numeric:true});}).forEach(function(card){
      var categoryMatch=activeFilter==='all'||hasFleetCategory(card,activeFilter);
      card.hidden=!categoryMatch || !!(fleetMake&&fleetMake.value&&vehicleBrand(card)!==fleetMake.value) || searchable(vehicleName(card)).indexOf(query)===-1;
      if(!card.hidden)visible++; card.parentElement.appendChild(card);
    });
    filterButtons.forEach(function(button){var selected=button.dataset.fleetFilter===activeFilter;button.classList.toggle('is-active',selected);button.setAttribute('aria-pressed',String(selected));});
    if(fleetResults)fleetResults.textContent=visible ? visible+' of '+fleetCards.length+' vehicles shown' : 'No matching cars. Reset the filters or ask our team for help.';
  }
  filterButtons.forEach(function(button){button.addEventListener('click',function(){activeFilter=button.dataset.fleetFilter;filterFleet();});});
  if(fleetSearch)fleetSearch.addEventListener('input',filterFleet);
  if(fleetMake)fleetMake.addEventListener('change',filterFleet);
  if(fleetSort)fleetSort.addEventListener('change',filterFleet);
  var fleetReset=document.querySelector('[data-fleet-reset]');
  if(fleetReset)fleetReset.addEventListener('click',function(){activeFilter='all';if(fleetSearch)fleetSearch.value='';if(fleetMake)fleetMake.value='';if(fleetSort)fleetSort.value='grouped';filterFleet();});
  filterFleet();

  var bookingVehicle = document.querySelector('[data-booking-vehicle]');
  var bookingPickup = document.querySelector('[data-booking-pickup]');
  var bookingReturn = document.querySelector('[data-booking-return]');
  var heroVehicle = document.querySelector('[data-hero-vehicle]');
  var heroPickup = document.querySelector('[data-hero-pickup]');
  var heroReturn = document.querySelector('[data-hero-return]');

  function localDateString(date) {
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');
    return year + '-' + month + '-' + day;
  }

  var today = localDateString(new Date());
  function updateDatePair(pickup, returnDate) {
    if (!pickup || !returnDate) return;
    pickup.min = today;
    returnDate.min = pickup.value || today;
    if (returnDate.value && returnDate.value < returnDate.min) {
      returnDate.value = returnDate.min;
    }
  }

  function watchDatePair(pickup, returnDate) {
    if (!pickup || !returnDate) return;
    updateDatePair(pickup, returnDate);
    pickup.addEventListener('change', function () { updateDatePair(pickup, returnDate); });
  }

  watchDatePair(heroPickup, heroReturn);
  watchDatePair(bookingPickup, bookingReturn);

  function selectVehicle(name) {
    if (!bookingVehicle || !name) return;
    var matching = Array.from(bookingVehicle.options).find(function (option) { return option.value === name || option.text === name; });
    if (matching) bookingVehicle.value = matching.value || matching.text;
  }
  document.querySelectorAll('[data-book-vehicle]').forEach(function (link) {
    link.addEventListener('click', function () { selectVehicle(link.getAttribute('data-book-vehicle')); });
  });

  var heroSubmit = document.querySelector('[data-hero-submit]');
  if (heroSubmit) {
    heroSubmit.addEventListener('click', function () {
      if (heroVehicle) selectVehicle(heroVehicle.value);
      if (bookingPickup && heroPickup) bookingPickup.value = heroPickup.value;
      if (bookingReturn && heroReturn) bookingReturn.value = heroReturn.value;
      updateDatePair(bookingPickup, bookingReturn);
    });
  }

  var params = new URLSearchParams(window.location.search);
  selectVehicle(params.get('vehicle'));
})();

// SSE navigation and location-aware requests.
(function(){
  var header=document.querySelector('.sse-header');
  var nav=document.getElementById('SseDiscoveryNav');
  var toggle=document.querySelector('.sse-discovery-toggle');
  var overlay=document.querySelector('.sse-nav-overlay');
  var mobile=window.matchMedia('(max-width:1100px)');
  function closeGroups(){if(nav)nav.querySelectorAll('details').forEach(function(group){group.open=false;});}
  function setMenu(open,returnFocus){if(!toggle||!nav)return;toggle.setAttribute('aria-expanded',String(open));toggle.setAttribute('aria-label',open?'Close navigation menu':'Open navigation menu');toggle.querySelector('span').textContent=open?'×':'☰';nav.classList.toggle('is-open',open);document.body.classList.toggle('sse-navigation-open',open);if(overlay)overlay.hidden=!open;if(!open){closeGroups();if(returnFocus)toggle.focus();}else{var first=nav.querySelector('summary,a');if(first)first.focus();}}
  if(toggle)toggle.addEventListener('click',function(){setMenu(toggle.getAttribute('aria-expanded')!=='true',false);});
  if(overlay)overlay.addEventListener('click',function(){setMenu(false,true);});
  if(nav){nav.querySelectorAll('details').forEach(function(group){group.addEventListener('toggle',function(){if(group.open)nav.querySelectorAll('details').forEach(function(other){if(other!==group)other.open=false;});});});nav.querySelectorAll('a').forEach(function(link){link.addEventListener('click',function(){setMenu(false,false);});});}
  document.addEventListener('click',function(event){if(header&&!header.contains(event.target))closeGroups();});
  document.addEventListener('keydown',function(event){if(event.key==='Escape'){if(toggle&&toggle.getAttribute('aria-expanded')==='true'){setMenu(false,true);}else if(nav){var opened=nav.querySelector('details[open]');if(opened){opened.open=false;opened.querySelector('summary').focus();}}}if(event.key==='Tab'&&mobile.matches&&toggle&&toggle.getAttribute('aria-expanded')==='true'){var elements=Array.from(header.querySelectorAll('a,button,summary')).filter(function(el){return el.getClientRects().length&&!el.disabled;});var first=elements[0],last=elements[elements.length-1];if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}}});
  if(mobile.addEventListener)mobile.addEventListener('change',function(){setMenu(false,false);});
  var params=new URLSearchParams(window.location.search);
  var locationField=document.querySelector('[data-booking-location]');var occasionField=document.querySelector('[data-booking-occasion]');var handoff=document.querySelector('[data-booking-handoff]');
  if(locationField&&params.get('location')){var requestedArea=params.get('location').slice(0,160);locationField.value=/^Bayonne(?:\s+pickup)?$/i.test(requestedArea)?'Bayonne, NJ':requestedArea;if(handoff)handoff.value='Please advise';}
  if(occasionField&&params.get('occasion'))occasionField.value=params.get('occasion').slice(0,160);
  var vehicleSelect=document.querySelector('[data-booking-vehicle]');
  if(vehicleSelect){var choices=Array.from(vehicleSelect.options).filter(function(option){return option.value&&option.value!=='Help me choose';});choices.sort(function(a,b){return a.text.replace(/^\d{4}\s+/,'').localeCompare(b.text.replace(/^\d{4}\s+/,''),'en',{numeric:true});});var help=Array.from(vehicleSelect.options).find(function(option){return option.value==='Help me choose';});choices.forEach(function(option){vehicleSelect.appendChild(option);});if(help)vehicleSelect.appendChild(help);}
})();

(function(){document.querySelectorAll('#SseBookingForm .sse-request-extras,#SseVehicleRequest .sse-request-extras').forEach(function(details){if(Array.from(details.querySelectorAll('input,textarea')).some(function(field){return field.value.trim();}))details.open=true;details.addEventListener('invalid',function(){details.open=true;},true);});})();
